module.exports = __webpack_public_path__ + "static/media/create-wall.ad06f368.gif";